import { FC, useState, useEffect } from 'react';
import {
  Modal,
  TextInput,
  CreatableSelectInput,
  TinyMCEInput,
  TinyMCEInputV2,
  TinyMCEMDInput,
} from '@wajeez-web/components/ui';
import { Identity } from '@wajeez-web/core/api-base';
import { CommonModalProps } from '@wajeez-web/components/modals';
import {
  useProductSelector,
  useProductDispatch,
  FAQsActions,
} from '@wajeez-web/stores/product';
interface FaqsModalProps extends CommonModalProps<Identity.CreateFaqInput> {
  onCreateNewFaqCategory: (val: string) => void;
  id?: number;
}
const FaqsModal: FC<FaqsModalProps> = ({
  id,
  isOpen,
  onClose,
  onSubmit,
  onCreateNewFaqCategory,
}) => {
  const { faqsCategoriesData, details } = useProductSelector((s) => s.faqs);
  const dispatch = useProductDispatch();
  const [bodyData, setBodydata] = useState<Identity.CreateFaqInput>({
    faqCategoryId: 0,
    question: '',
    answer: '',
  });
  useEffect(() => {
    if (id) {
      dispatch(FAQsActions.getFaqByIdAsync(id));
    }
    return () => {
      dispatch(FAQsActions.clearDetails());
    };
  }, [id]);

  useEffect(() => {
    if (details) {
      setBodydata({
        faqCategoryId: details.categoryId,
        question: details.question,
        answer: details.answer,
      });
    }
  }, [details]);

  const handleChange = (name: string, value: string) => {
    setBodydata({ ...bodyData, [name]: value });
  };
  return (
    <Modal
      title={'FAQ Modal'}
      open={isOpen}
      onClose={onClose}
      onSubmit={() => onSubmit && onSubmit(bodyData)}
    >
      <div className=" space-y-2">
        <TextInput
          name="question"
          value={bodyData.question}
          onChange={handleChange}
          label={'Question'}
        />
        <CreatableSelectInput
          label="Faq Category"
          value={
            (bodyData?.faqCategoryId &&
              faqsCategoriesData
                .map((item) => ({ label: item.name, value: item.id }))
                .find((item) => item.value === bodyData.faqCategoryId)) ||
            undefined
          }
          options={faqsCategoriesData.map((item) => ({
            label: item.name,
            value: item.id,
          }))}
          onChange={(name, val: any) => {
            setBodydata({ ...bodyData, faqCategoryId: Number(val.value) });
          }}
          onCreate={onCreateNewFaqCategory}
          name={'categories'}
        />

        <TinyMCEMDInput
          name="answer"
          value={bodyData.answer}
          onChange={handleChange}
          label={'answer'}
        />
      </div>
    </Modal>
  );
};

export default FaqsModal;
